import React, { useMemo, memo } from "react";
import volunteerData from "../data/volunteerData";

const Volunteer = memo(() => {
  const items = useMemo(() => volunteerData, []);

  return (
    <section
      className=" text-primary w-full flex flex-col items-center "
      aria-labelledby="volunteer-title"
    >
      {/* العنوان الرئيسي */}
      <div className="relative w-full inline-block text-center md:mb-12 mb-4">
        <h1
          id="volunteer-title"
          className="text-xl md:text-3xl font-bold font-qomra inline-block"
        >
          من خلال بناة يمكنك التطوع في
        </h1>
      </div>

      {/* شبكة الخدمات */}
      <div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 w-full max-w-7xl px-4"
        role="list"
        aria-label="مجالات التطوع المتاحة"
      >
        {items.map(({ id, icon, alt, title, description }) => (
          <article
            key={id}
            className="flex flex-col items-center text-center p-3 lg:p-4  rounded-lg group"
            role="listitem"
            tabIndex="0"
            aria-label={`مجال التطوع: ${title}`}
          >
            {/* دائرة تحتوي الأيقونة */}
            <img
              src={icon}
              alt={alt}
              className="h-20 w-20 md:h-20 md:w-20 lg:h-32 lg:w-32 group-hover:scale-110 transition-transform duration-300 mb-2"
              loading="lazy"
            />

            {/* العنوان */}
            <div className="min-h-[60px] lg:min-h-[72px] flex items-center justify-center ">
              <h3 className="text-base md:text-base lg:text-lg xl:text-xl font-semibold font-qomra leading-tight text-blackText">
                {title}
              </h3>
            </div>

            {/* الوصف */}
            <p className="text-base md:text-sm lg:text-base text-blackText leading-relaxed">
              {description}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
});

Volunteer.displayName = "Volunteer";

export default Volunteer;
